import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      es: {
        translation: {
          errors: {
            credentials_not_match: 'El correo electrónico o la contraseña son incorrectos',
            email_already_taken: 'Este correo electrónico ya está en uso',
            email_not_found: 'El correo electrónico no existe',
            invalid_token: 'El token es inválido, vuelve a enviar el correo electrónico de verificación',
            username_already_taken: 'Este nombre de Username ya está en uso',
          },
        },
      },
    },
  });

export default i18n;
